import { useEffect } from 'react';
import UsersTable from './UsersTable';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPortalUsers } from '../../store/portalUsersSlice';
import { useNavigate } from 'react-router-dom';

const PortalAccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { portalRole } = useSelector((state) => state.user.user);

  useEffect(() => {
    if (portalRole !== 'admin') {
      navigate('/');
    }
  }, [portalRole, navigate]);

  useEffect(() => {
    dispatch(fetchPortalUsers());
  }, [dispatch]);

  const { portalUsers, isLoading, error } = useSelector((state) => state.portalUsers);

  return (
    <div className="pl-[64px] pt-[24px] h-full">
      <div className="bg-white rounded-[12px] py-[20px] px-[16px]">
        <h2 className="text-[22px] font-medium mb-[8px]">Portal Access</h2>
        <p className="text-[14px]">
          {
            'All accounts go through an approval process by Roam to ensure no unauthorised individuals  access client sensitive data. Below is a list of users approved by Roam to view the client portal and the site(s) data applicable to your account.'
          }
        </p>
      </div>
      <UsersTable isLoading={isLoading} error={error} portalUsers={portalUsers} />
    </div>
  );
};

export default PortalAccess;
